<template>
  <v-dialog v-model="dialog" scrollable width="800">
    <v-card v-if="item">
      <v-toolbar color="primary" dense dark class="elevation-0">
        <v-toolbar-title>Chi tiết đề xuất {{ item.code }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-6">
        <v-row dense class="mb-3">
          <v-col cols="6">
            <span class="grey--text">Mã đề xuất:</span>
            <strong class="primary--text ml-2">{{ item.code }}</strong>
          </v-col>
          <v-col cols="6">
            <span class="grey--text">Trạng thái:</span>
            <v-chip x-small :color="getStatusColor(item.status)" dark class="ml-2">
              {{ getStatusLabel(item.status) }}
            </v-chip>
          </v-col>
          <v-col cols="12">
            <span class="grey--text">Tiêu đề:</span>
            <strong class="ml-2">{{ item.title }}</strong>
          </v-col>
          <v-col cols="6">
            <span class="grey--text">Người đề xuất:</span>
            <span class="ml-2 font-weight-medium">{{ item.proposer }}</span>
          </v-col>
          <v-col cols="6">
            <span class="grey--text">Phòng ban / Tổ:</span>
            <span class="ml-2 font-weight-medium">{{ item.department || '-' }}</span>
          </v-col>
          <v-col cols="12">
            <span class="grey--text">Lý do & Mục đích:</span>
            <div class="mt-1 pa-2 grey lighten-4 rounded">{{ item.justification }}</div>
          </v-col>
        </v-row>

        <v-divider class="my-3" />

        <div class="d-flex justify-space-between align-center mb-2">
          <div class="text-subtitle-2 font-weight-bold">DANH SÁCH MẶT HÀNG ĐỀ XUẤT</div>
          <div class="primary--text font-weight-bold">
            Tổng dự toán: {{ (item.totalEstimatedCost || 0).toLocaleString('vi-VN') }} đ
          </div>
        </div>

        <v-simple-table dense class="elevation-1">
          <template v-slot:default>
            <thead>
              <tr class="grey lighten-4">
                <th>STT</th>
                <th>Tên thiết bị</th>
                <th>Cấu hình</th>
                <th class="text-center">Số lượng</th>
                <th class="text-center">Đơn vị</th>
                <th class="text-right">Đơn giá dự kiến</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(it, idx) in item.items || []" :key="idx">
                <td>{{ idx + 1 }}</td>
                <td><strong>{{ it.name }}</strong></td>
                <td>{{ it.specifications || '-' }}</td>
                <td class="text-center font-weight-bold">{{ it.quantity }}</td>
                <td class="text-center">{{ it.unit || 'Bộ' }}</td>
                <td class="text-right">{{ (it.estimatedPrice || 0).toLocaleString('vi-VN') }} đ</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>

        <div v-if="item.rejectReason" class="mt-3 red--text">
          <strong>Lý do từ chối:</strong> {{ item.rejectReason }}
        </div>
      </v-card-text>

      <v-divider />
      <v-card-actions class="pa-4">
        <template v-if="!isTeacher && item.status === 'SUBMITTED'">
          <v-btn color="error" text @click="rejectDialog = true">
            <v-icon left small>mdi-close</v-icon> Từ chối
          </v-btn>
          <v-spacer />
          <v-btn outlined color="grey darken-1" class="mr-2" @click="dialog = false">
            Đóng
          </v-btn>
          <v-btn color="success" depressed @click="approveDialog = true">
            <v-icon left small>mdi-check</v-icon> Phê duyệt ngân sách
          </v-btn>
        </template>
        <template v-else>
          <v-spacer />
          <v-btn outlined @click="dialog = false">Đóng</v-btn>
        </template>
      </v-card-actions>
    </v-card>

    <!-- Dialog phê duyệt đề xuất -->
    <ProposalApproveDialog :state="approveDialog" :item="item" @updated="onActionSuccess" />

    <!-- Dialog từ chối đề xuất -->
    <ProposalRejectDialog :state="rejectDialog" :item="item" @updated="onActionSuccess" />
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ProposalApproveDialog from '@/modules/facility/proposal/ProposalApproveDialog.vue'
import ProposalRejectDialog from '@/modules/facility/proposal/ProposalRejectDialog.vue'

export default {
  name: 'ProposalDetailDialog',
  components: {
    ProposalApproveDialog,
    ProposalRejectDialog
  },
  props: {
    state: Boolean,
    item: Object
  },
  data() {
    return {
      dialog: false,
      approveDialog: false,
      rejectDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['role']),
    isTeacher() {
      return this.role && this.role.name === 'Teacher'
    }
  },
  watch: {
    state(val) {
      if (val) this.dialog = true
    }
  },
  methods: {
    ...mapActions('FacilityProposals', ['updateProposal']),
    getStatusLabel(status) {
      switch (status) {
        case 'DRAFT': return 'Bản nháp'
        case 'SUBMITTED': return 'Chờ duyệt'
        case 'APPROVED': return 'Đã duyệt'
        case 'REJECTED': return 'Từ chối'
        case 'PURCHASING': return 'Đang mua sắm'
        case 'DONE': return 'Đã hoàn tất'
        default: return status
      }
    },
    getStatusColor(status) {
      switch (status) {
        case 'DRAFT': return 'blue-grey'
        case 'SUBMITTED': return 'warning'
        case 'APPROVED': return 'indigo'
        case 'REJECTED': return 'error'
        case 'PURCHASING': return 'primary'
        case 'DONE': return 'success'
        default: return 'grey'
      }
    },
    onActionSuccess() {
      this.dialog = false
      this.$emit('updated')
    }
  }
}
</script>
